<script setup lang="ts">
// PROPS
interface Props {
    salesContact: SalesContact;
}

const { salesContact } = defineProps<Props>();

// COMPOSABLES
const { trackSalesContactWhatsappButton } = useTracking();
</script>

<template>
    <UButton
        icon="fl:whatsapp"
        color="success"
        size="xl"
        :to="salesContact.whatsAppLink"
        target="_blank"
        square
        @click="trackSalesContactWhatsappButton"
    />
</template>
